module.exports = __webpack_public_path__ + "static/media/search.626a5001.png";